<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="display: flex; flex-flow: column; height: 100%;" class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>
            <v-row justify="center" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; max-height: 50px">
                <v-col class="ml-4 mt-0 pt-1 RestoRegular">
                    <v-row style="font-size: 18px; color: #4D4D4D" class="pt-2">
                        ¡Ya casi terminamos!
                    </v-row>
                    <!-- ##### ALERTA FALTA CAMPO ##### -->
                    <!-- <v-snackbar v-model="alert1" class="font" :top="true" color="warning">
                        ¡Falta llenar algún campo!
                    </v-snackbar>
                    <v-snackbar v-model="alert2" class="font" :top="true" color="info">
                        Acepta los políticas de Privacidad
                    </v-snackbar>
                    <v-snackbar v-model="alert3" class="font" :top="true" color="error">
                        Las contraseñas no coinciden
                    </v-snackbar>  -->
                </v-col>
            </v-row>
                
            <!-- New content -->
            <v-row style="flex-grow : 1;" class="py-0 my-0" >
                <v-col style="height: 100%" class="py-0 my-0">
                    <v-row class="pt-1 pl-4 pr-4 pb-0">
                        <transition name="hint" appear>
                            <div v-if='passwordValidation.errors.length > 0 && !submitted' class='font'>
                                <strong>Contraseña que contenga: </strong>
                                <span style="margin: 0; padding: 0" v-for="(error, index) in passwordValidation.errors" :key="index">{{ error }}</span>
                            </div>
                        </transition>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;" class="pt-4 pb-0 mb-0">
                        <v-text-field
                            v-model="password"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.minRequeriments]"
                            :type="showPassword ? 'text' : 'password'"
                            :class="{valid:passwordValidation.valid}"
                            name="input-10-1"
                            label="Contraseña"
                            outlined
                            @click:append="showPassword = !showPassword"
                        ></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field
                            v-model="confirPassword"
                            :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.equals]"
                            :type="showPass2 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Confirma tu contraseña"
                            hide-details
                            outlined
                            @click:append="showPass2 = !showPass2"
                        ></v-text-field>
                    </v-row>

                    <v-row align="center" style="max-width: 300px; margin: 0 auto;" class="mt-4">
                        <v-checkbox v-model="terms" :color="$store.state.colors.primary" hide-details></v-checkbox>
                        <span class="pt-5">Acepto las</span><span class="pt-5 pl-1 RestoBold" :style="{ 'color': $store.state.colors.primary }">
                            <a @click="goToPDF" style="background-color: transparent" :style="{ 'color': $store.state.colors.primary }" >políticas de privacidad </a> 
                        </span>
                    </v-row>
                    <br>
                    <!-- <v-snackbar v-model="alert" :top="true" color="error">
                        {{alert_message}}
                    </v-snackbar> -->
                </v-col>
            </v-row>
            <!-- Button Continue -->
            <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%" class="mt-8" >
                <br><br><br>
                <v-btn :loading="loading" @click="goTo()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px;">Continuar</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                </v-btn>
            </v-row>
            <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%"  >
                <v-btn @click="$router.push({ name: 'registerStep2'});" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px; color: $store.state.colors.primary">Regresar</span>
                    <v-spacer></v-spacer>
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import axios from 'axios'
export default {
    data () {
        return {
            loading: false,
            alert: false,
            alert_message: "",
            alert1: false,
            alert2: false,
            alert3: false,
            password: '',
            confirPassword: null,
            showPassword: false,
            showPass2: false,
            terms: false,
            passPattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            rules: 
            {
                equals: c => c ? (c == this.password || 'Las contraseñas no coinciden') : true, 
                minRequeriments: value => { return value ? (this.passPattern.test(value) || 'Contraseña no válida') : true },
                required: value => !!value || ''
            },
            checkPassword:'',
			submitted:false,
            rules2: 
            [
                { message:'1 Mayúscula, ', regex:/[A-Z]+/  }, 
                { message:'1 Minúscula, ', regex:/[a-z]+/ }, 
                { message:'1 Número, ', regex:/[0-9]+/ },
                { message:"8 Caracteres", regex:/.{8,}/ }, 
			],
        }
    },
    created() 
    {
        this.$store.state.logo = false;
    },
    methods:
    {
        goToPDF() {
            // const headers = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
            var username = 'swyt1';
            var password = 'r3stoDirec0.y';
            var basicAuth = 'Basic ' + btoa(username + ':' + password);
            this.$store.dispatch("GET", {url: 'avisos/' + localStorage.getItem("codigo_marca"), headers: { 'Content-Type': 'application/json', 'Authorization': basicAuth}})
            .then(response => {
                // console.log(response);
                window.open(response.data[0].baner, '_blank');
            })
            .catch(error => {
                console.log("Error: " + error);
            });
        },
        resetPasswords () 
		{
			this.password = ''
			this.checkPassword = ''
			this.submitted = true
			setTimeout(() => {this.submitted = false}, 2000)
		},
        async goTo()
        {
            this.loading = true;
            if(this.passwordValidation.errors.length == 0)
            {
                if((!!this.password && !!this.confirPassword))
                {
                    if(this.password == this.confirPassword)
                    {
                        if(this.terms == false)
                        {
                            this.loading = false;
                            this.$store.state.alertState = true;
                            this.$store.state.alertMessage = "Acepta las políticas de privacidad";
                            this.$store.state.alertColor = "info";
                            setTimeout(() => {
                            this.$store.state.alertState = false;
                            }, 4000);
                        }
                        else
                        {
                            this.$store.state.newUserData.pass = this.password;
                            var username = 'swyt1';
                            var password = 'r3stoDirec0.y';
                            var basicAuth = 'Basic ' + btoa(username + ':' + password);
                            const headers = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
                            

                            await axios.post('/altaCli_Dir', this.$store.state.newUserData, {headers: headers} )
                                .then(res => {
                                
                                // console.log("User data: ", this.$store.state.newUserData)
                                console.log(res);
                                    if(res.data.mensaje == 'Cliente y direccion creados')
                                    {
                                        this.loading = false;
                                        localStorage.setItem("token",res.data.token);
                                        localStorage.setItem("original_id_sucursal",res.data.id_sucursal)
                                        localStorage.setItem("id_sucursal",res.data.id_sucursal)
                                        if(res.data.id_sucursal == 0)
                                            localStorage.setItem("alertNoAddresses", "true")
                                        localStorage.setItem("id_cliente",res.data.id_cliente);
                                        localStorage.setItem('email', this.$store.state.newUserData.correo);    
                                        this.$router.push({ name: 'welcome'});
                                        this.$store.state.token = res.data.token;
                                    }
                                    else if(res.data.mensaje == "Cliente ya existe"){
                                        this.loading = false;
                                        this.alert_message = res.data.mensaje;
                                        this.$store.state.alertState = true;
                                        this.$store.state.alertMessage = this.alert_message;
                                        this.$store.state.alertColor = "warning";
                                        setTimeout(() => {
                                            this.$store.state.alertState = false;
                                            this.$router.push({ name: 'verification'});
                                        }, 4000);
                                    }
                                    else if(res.data.mensaje == "No hay cobertura en tu zona"){
                                        this.loading = false;
                                        this.$store.state.alertState = true;
                                        this.$store.state.alertMessage = "No hay cobertura en tu zona";
                                        this.$store.state.alertColor = "error";
                                        setTimeout(() => {
                                        this.$store.state.alertState = false; this.$router.push({ name: 'ubication'}); }, 4000);
                                    }
                                    else
                                    {
                                        this.loading = false;
                                        this.alert_message = res.data.mensaje;
                                        this.$store.state.alertState = true;
                                        this.$store.state.alertMessage = this.alert_message;
                                        this.$store.state.alertColor = "warning";
                                        setTimeout(() => {
                                        this.$store.state.alertState = false;
                                        }, 4000);
                                    }
                            })
                            .catch(error => {
                                console.log(error);
                                this.loading = false;
                            })
                        }
                    }
                    else
                    {
                        this.loading = false;
                        this.$store.state.alertState = true;
                        this.$store.state.alertMessage = "Las contraseñas no coinciden";
                        this.$store.state.alertColor = "error";
                        setTimeout(() => {
                        this.$store.state.alertState = false;
                        }, 4000);
                    }
                }
                else
                {
                    this.loading = false;
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = "¡Falta llenar algún campo!";
                    this.$store.state.alertColor = "warning";
                    setTimeout(() => {
                    this.$store.state.alertState = false;
                    }, 4000);
                }
            }
            else {
                this.loading = false;
                this.alert_message = "La contraseña no es correcta";
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = this.alert_message;
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);
            }
        }

    },
    computed:
    {
        passwordsFilled () 
		{
			return (this.password !== '' && this.checkPassword !== '')
		},
		passwordValidation () 
		{
			let errors = []
			for (let condition of this.rules2) 
			{
				if (!condition.regex.test(this.password)) 
				{
					errors.push(condition.message)
				}
            }
			if (errors.length === 0) 
			{
				return { valid:true, errors }
			} 
			else 
			{
				return { valid:false, errors }
			}
		}
    }
}
</script>

<style scoped>
.disable-events 
{
    pointer-events: none;
}
.font
{
	font-size: 16px;
}
</style>
